import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getUserWorks({ userId }) {
  try {
    const works = yield call(API.getUserWorks, userId);
    yield put({ type: actionTypes.USER_WORKS_GET_SUCCESS, works });
  } catch (error) {
    yield put({ type: actionTypes.USER_WORKS_GET_ERROR, error });
  }
}

export function* getWork({ workId }) {
  try {
    const work = yield call(API.getWork, workId);
    if (work.id) {
      yield put({ type: actionTypes.WORK_GET_SUCCESS, work });
    } else {
      yield put({ type: actionTypes.WORK_GET_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.WORK_GET_ERROR, error });
  }
}

export function* createWork({ work }) {
  try {
    const result = yield call(API.createWork, work);
    if (result.error) {
      yield put({ type: actionTypes.WORK_CREATE_ERROR, error: result.error });
    } else {
      yield put({ type: actionTypes.WORK_CREATE_SUCCESS, work: result });
    }
  } catch (error) {
    yield put({ type: actionTypes.WORK_CREATE_ERROR, error });
  }
}

export function* updateWork({ workId, work }) {
  try {
    const result = yield call(API.updateWork, workId, work);
    if (result.id) {
      yield put({ type: actionTypes.WORK_UPDATE_SUCCESS, work: result });
    } else {
      yield put({ type: actionTypes.WORK_UPDATE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.WORK_UPDATE_ERROR, error });
  }
}

export function* deleteWork({ workId }) {
  try {
    yield call(API.deleteWork, workId);
    yield put({ type: actionTypes.WORK_DELETE_SUCCESS, workId });
  } catch (error) {
    yield put({ type: actionTypes.WORK_DELETE_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/works.js